/* global $, Swiper, TouchNSwipe, ShopgateProductDetailsCore */
import shopgateStepByStepSelectionUI from '../../common/product_details/jquery.shopgate-product-stepbystep-ui-plugins';
import productDetailsUIHelpers from '../../common/product_details/ui-helpers';

/**
 * @param {ShopgateProductDetailsCore} _productDetailsCore
 * @param {object} params
 */
var shopgateUI = function (_productDetailsCore, params) {

  $.sgHelpers = $.sgHelpers || {};
  $.shopgate = $.shopgate || {};

  var scope = null,
    productHeadline = null,
    productContainerPriceMainNormal = null,
    productContainerPriceMainDiscounted = null,
    productContainerPrice = null,
    productContainerPriceLabel = null,
    productContainerPriceOld = null,
    productContainerPriceOldLabel = null,
    productContainerPriceDiscount = null,
    productContainerPriceDiscountLabel = null,
    productContainerAmountInfoText = null,
    productContainerPriceTag = null,
    productContainerBlockPricing = null,
    productContainerStockInfo = null,
    productContainerLiveStock = null,
    productContainerAvailableText = null,
    productContainerShippingInfo = null,
    productDescription = null,
    productProperties = null,
    productDescriptionTabs = null,
    attributesContainer = null,
    optionsContainer = null,
    inputFieldsContainer = null,
    cartButton = null,
    productImagesSwiper = null,
    $swiperContainer = null,
    $swiperWrapper = null,
    $swiperPagination = null,
    $tnsContainer = null,
    pricePreloader = null,
    $vendorPaymentButtons,
    transitionEndEvents = 'oTransitionEnd transitionend transitionEnd webkitTransitionEnd';

  var cartButtonLocked = false;
  var cartButtonBusy = false;

  function _onCoreInit(callType, data) {
    if (callType != 'products.ui') {
      return false;
    }

    scope = $('#content > .product');
    productHeadline = $('.product-frame h1', scope);
    productContainerPriceMainNormal = $('.main-container-price-normal', scope);
    productContainerPriceMainDiscounted = $('.main-container-price-discounted', scope);
    productContainerPrice = $('.container-price .js-container-price', scope);
    productContainerPriceLabel = $('.container-price-label', scope);
    productContainerPriceOld = $('.container-price-old', scope);
    productContainerPriceOldLabel = $('.container-price-old-label', scope);
    productContainerPriceDiscount = $('.container-price-discount .js-container-price', scope);
    productContainerPriceDiscountLabel = $('.container-price-discount-label', scope);
    productContainerAmountInfoText = $('.container-amount-info-text', scope);
    productContainerPriceTag = $('.container-price-tag', scope);
    productContainerBlockPricing = $('.container-block-pricing', scope);
    productContainerStockInfo = $('.container-stock-info', scope);
    productContainerLiveStock = $('.container-live-stock');
    productContainerAvailableText = $('.container-available-text', scope);
    productContainerShippingInfo = $('.container-shipping-info', scope);
    productDescription = $('#product-description .product-description-placeholder', scope);
    productProperties = $('#product-properties .product-properties-content', scope);
    productDescriptionTabs = $('.product-info-tabs', scope);
    attributesContainer = $('.product-attributes', scope);
    optionsContainer = $('.product-options', scope);
    inputFieldsContainer = $('.product-input-fields', scope);
    cartButton = $('.btn-cart', scope);
    $swiperContainer = $('.product-images-swiper', scope);
    $swiperWrapper = $('.swiper-wrapper', $swiperContainer);
    $swiperPagination = $('.product-images-swiper-pagination', $swiperContainer);
    $tnsContainer = $('#tnsContainer');
    pricePreloader = $('.js-price-preloader', scope);
    $vendorPaymentButtons = $('.payment-btns', scope);

    // fields for changing quantity
    $('.container-product-quantity').each(function () {
      var $this = $(this),
        $itemAmount = $this.find('.item-amount'),
        minQuantity = parseInt($this.data('quantity-min'));

      if (isNaN(minQuantity)) {
        minQuantity = 1;
      }

      // handle the plus-btn
      $this.find('.item-plus').unbind('click').click(function () {
        $this.addClass('pressed');
        updateQuantity(parseInt($itemAmount.val()) + 1);
      }).unbind(transitionEndEvents).bind(transitionEndEvents, function () {
        $this.removeClass('pressed');
      });

      // handle the minus-btn
      $this.find('.item-minus').unbind('click').click(function () {
        $this.addClass('pressed');
        updateQuantity(parseInt($itemAmount.val()) - 1);
      }).unbind(transitionEndEvents).bind(transitionEndEvents, function () {
        $this.removeClass('pressed');
      });

      // handle amount input
      $itemAmount.unbind('blur').bind('blur', function () {
        updateQuantity(parseInt($itemAmount.val()));
      });

      // When the value changed save it and update productDetailsCore
      // (this automatically updates the input fields with _onUpdateCartProductQuantity)
      function updateQuantity(value) {

        if (!$.isNumeric(value) || value % 1 !== 0 || value < minQuantity) {
          value = minQuantity;
        }

        if (shopSettings.productDisplayListWithCta && _productDetailsCore.products.parent.product.display_type == _productDetailsCore.DISPLAY_TYPE_LIST) {
          // Don't update core for grouped products with add-to-cart button on each child
          $itemAmount.val(value);
        } else {
          _productDetailsCore.updateCartProductQuantity(value, $this.data('product-id'));
        }
      }
    });

    // add to cart
    cartButton.unbind('click').click(function () {
      if (shopSettings.productDisplayListWithCta && _productDetailsCore.products.parent.product.display_type == _productDetailsCore.DISPLAY_TYPE_LIST) {
        // Update quantity for current child before adding to cart
        var quantityContainer = $(this).siblings('.container-product-quantity'),
          $itemAmount = quantityContainer.find('.item-amount');
        _productDetailsCore.updateCartProductQuantity($itemAmount.val(), quantityContainer.data('product-id'));
      }

      var added = _productDetailsCore.addProductToCart();
      if (!added) {
        _focusOnUndecided();
      }
    }).unbind(transitionEndEvents).bind(transitionEndEvents, function (e) {
      $(this).removeClass('pressed');
    });

    $vendorPaymentButtons
      .off('click')
      .on('click', function () {
        var disabled = $(this).find('.locked').length;
        if (disabled) {
          _focusOnUndecided();
        }
      });
  }

  /**
   * Focus browser on first undecided decision
   * (stepByStep or first required and empy input).
   *
   * Does nothing if there is nothing to decide for user.
   *
   * Sadly, this logic if adjusted must be copier for
   * each of ui plugins.
   *
   * @private
   */
  function _focusOnUndecided() {
    var interactionDone = false;
    if (_productDetailsCore.isStepByStepMode() && !_productDetailsCore.getState(_productDetailsCore.getProductSelectionStates.STATE_STEPBYSTEP_SELECTION_DONE)) {
      interactionDone = _focusOnNextStepByStepDecision();
    }
    if (!interactionDone) {
      _focusOnInvalidInputs();
    }
    /** @todo what should happen if both fail? #fe-142 */
  }

  /**
   * Focuses UI on first input which is marked as invalid
   * by _core script.
   *
   * @returns {boolean} (true if focus attempted, false if there was nothing to focus)
   *
   */
  function _focusOnInvalidInputs() {
    var $inputsWithError = $('.product-input-fields-wrapper .has-error');

    if (!$inputsWithError.length) {
      return false;
    }

    $.shopgate.scrollTo($inputsWithError.get(0));

    $inputsWithError.first().find('.control-label').trigger('click');

    return true;
  }

  /**
   * Asks stepByStep singleton object (if inited)
   * to focus UI on first undecided selection.
   *
   * @returns {boolean} (true if focus was attempted, false if there was nothing to focus on)
   */
  function _focusOnNextStepByStepDecision() {
    if (typeof shopgateStepByStepSelectionUI === 'function') {
      var didFocus = new shopgateStepByStepSelectionUI().focusOnNextDecision({
        markUndecidedInvalid: true
      });

      return didFocus;
    }
  }

  /**
   * Updates the product after choice is changed
   *
   * @param callType
   * @param data
   * @returns {boolean}
   * @private
   */
  function _onUpdateProduct(callType, data) {
    if (callType != 'products.ui') {
      return false;
    }

    if (callType == 'products.ui') {
      // hide all wrapper
      scope.find('.product-attributes-wrapper, .product-options-wrapper, .product-input-fields-wrapper').hide();

      if (data && data.product && data.product.deeplink_onlineshop) {
        var deeplink = $('.back-link'),
          actionParams = deeplink.data('sgactionparams');

        deeplink.prop({
          href: data.product.deeplink_onlineshop
        });
        actionParams.src = data.product.deeplink_onlineshop;
        deeplink.data('sgactionparams', actionParams);
      }

      /**
       * Adds a product attribute to the list of product attributes
       * @param {string} productAttribute
       */
      function addProductAttribute(productAttribute) {
        var attributeElementContainer = $('<div>').addClass('row product-frame').prop({
            id: 'attribute_' + productAttribute.product_attribute.id
          }),
          attributeElementSelect = $('<select>').addClass('form-control selectpicker show-tick').attr({
            id: 'attribute_select_value_' + productAttribute.product_attribute.id
          }),
          attributeElementSelectFirstOption = $('<option>').addClass('no-sg-action').html(productAttribute.product_attribute.value).attr('data-subtext', productAttribute.product_attribute.name + ': ');

        // append the select to the container
        attributesContainer.append(attributeElementContainer.append(attributeElementSelect.append(attributeElementSelectFirstOption)));

        // (re-)initialize select
        attributeElementSelect.selectpicker({
          style: 'btn-default',
          dropupAuto: true,
          showSubtext: true
        });

        attributeElementSelect.change(function () {
          var productId = attributeElementSelect.val();

          _productDetailsCore.updateSelectedProductAttributeValue(productId, productAttribute.product_attribute.id);
        });


        var selectPicker = attributeElementContainer.children('.bootstrap-select');
        selectPicker.on('show.bs.dropdown', function () {
          _productDetailsCore.getProductAttributeValuesForProductAttributeId(productAttribute.product_attribute.product_id, productAttribute.product_attribute.id);
        });
        selectPicker.on('hide.bs.dropdown', function () {
          _productDetailsCore.hideVisibleProductAttributeValuesLists(productAttribute.product_attribute.product_id, productAttribute.product_attribute.id);
        });
      }

      /**
       * Adds a product option to the list of product options
       * @param {string} productOption
       */
      function addProductOption(productOption) {

        var optionElementContainer = $('<div>').addClass('row product-frame').prop({
            id: 'option_value_' + productOption.product_option.id,
          }),
          optionElementSelect = $('<select>').addClass('form-control selectpicker show-tick').attr({
            id: 'option_select_value_' + productOption.product_option.id,
          }).css({
            'display': 'none'
          }),
          optionElementSelectFirstOption = $('<option>').addClass('no-sg-action').html(productOption.product_option.value).attr('data-subtext', productOption.product_option.name + ': ');

        // append the select to the container
        optionsContainer.append(optionElementContainer.append(optionElementSelect.append(optionElementSelectFirstOption)));

        // (re-)initialize select
        optionElementSelect.selectpicker({
          style: 'btn-default',
          dropupAuto: true,
          showSubtext: true
        });

        optionElementSelect.change(function () {
          var productOptionValueId = optionElementSelect.val();
          _productDetailsCore.updateSelectedProductOptionValue(productOption.product_option.product_id, productOption.product_option.id, productOptionValueId);
        });

        var selectPicker = optionElementContainer.children('.bootstrap-select');
        selectPicker.on('show.bs.dropdown', function () {
          _productDetailsCore.getProductOptionValuesForProductOptionId(productOption.product_option.product_id, productOption.product_option.id);
        });
        selectPicker.on('hide.bs.dropdown', function () {
          _productDetailsCore.hideVisibleProductOptionValuesLists();
        });
      }

      /**
       * Adds a product input field to the list of product input fields
       * @param {string} productInputField
       */
      function addProductInputField(productInputField) {
        var inputLabelText = productInputField.product_input_field.label;

        if (productInputField.product_input_field.additional_amount_display != 0 && !productInputField.product_input_field.is_required) {
          var prefix = productInputField.product_input_field.additional_amount_display < 0 ? '' : '+';
          inputLabelText += ' (' + prefix + productInputField.product_input_field.price_info.additional_amount_display_formatted + ')';
        }

        if (productInputField.product_input_field.is_required) {
          inputLabelText += ' *';
        }

        var formGroup = $('<div>').addClass('form-group'),
          formLabel = $('<label>').addClass('control-label').html(inputLabelText),
          formInputGroup = $('<div>').addClass('input-group'),
          formInput = $('<input>').addClass('form-control').prop({
            id: 'input_' + productInputField.product_input_field.id
          }).val(productInputField.product_input_field.value),
          formRequiredHint = null;

        if (productInputField.product_input_field.infotext) {
          formRequiredHint = $('<span>').addClass('input-group-addon').html('?');

          formRequiredHint.click(function () {
            $.shopgate.modal({
              title: $.i18n._('modal_alert_title_description'),
              body: productInputField.product_input_field.infotext
            });
          });
        }

        if (formRequiredHint) {
          inputFieldsContainer.append(formGroup.append(formLabel, formInputGroup.append(formInput, formRequiredHint)));
        } else {
          inputFieldsContainer.append(formGroup.append(formLabel, formInput));
        }

        if (productInputField.product_input_field.is_required) {
          formInput.prop({
            placeholder: $.i18n._('product_input_placeholder_required')
          });
          if (productInputField.product_input_field.is_valid) {
            formInput.closest('.form-group').removeClass('has-error');
          } else {
            formInput.closest('.form-group').addClass('has-error');
          }
        }


        formInput.bind('input', function () {
          _productDetailsCore.updateProductInputFieldValue(productInputField.product_input_field.product_id, productInputField.product_input_field.id, $(this).val());
        });
      }

      /**
       * Helper function to update the block price containers of grouped and normal products
       * @param {Object} $container - The container-block-price element where the text should be updated
       * @param {Object} blockPricing - The block price data of an item
       * @param {boolean} isGroupedProduct - If the data is displayed in a grouped product
       * @private
       */
      function _updateBlockPriceContainer($container, blockPricing, isGroupedProduct) {
        var blockPricingText = '';

        blockPricing.forEach(function (priceGroup) {
          if (isGroupedProduct) {
            blockPricingText += '<p>' + priceGroup.text + '</p>';
          } else {
            blockPricingText += '<p class="col-xs-5 text-right">' + priceGroup.label + ':</p>';
            blockPricingText += '<p class="col-xs-7 text-left">' + priceGroup.unit_amount_display_formatted + '</p>';
          }
        });

        $container
          .html(blockPricingText)
          .show();
      }

      // handle the product information
      if (data.product) {
        var productFields = data.product;

        // set the product headline
        if (productFields.product.name) {
          productHeadline.html(productFields.product.name);
        }

        productDetailsUIHelpers.updateProductLabels(data.product.product.product_labels);

        // update the container-product-quantity data attr
        $('.container-product-quantity').not('.grouped-quantity').attr('data-product-id', productFields.product.id).data('product-id', productFields.product.id);

        // change block pricing information
        if (_productDetailsCore.products.parent.product.display_type == _productDetailsCore.DISPLAY_TYPE_LIST) {

          $('.child-list .single-product').each(function () {
            var id = $(this).data('productId'),
              $childProductContainerBlockPricing = $('.container-block-pricing', $(this)).empty().hide(), // reset block price container
              childProduct = _productDetailsCore.products.children[id].product;

            if (childProduct.has_block_pricing && childProduct.price_info.hasOwnProperty('block_pricing') && childProduct.price_info.block_pricing.length > 1) {
              _updateBlockPriceContainer($childProductContainerBlockPricing, childProduct.price_info.block_pricing, true);
            }
          });

        } else {
          // reset block price container
          productContainerBlockPricing
            .empty()
            .hide();

          if (productFields.product.has_block_pricing && productFields.product.price_info.hasOwnProperty('block_pricing') && productFields.product.price_info.block_pricing.length > 1) {
            if (_productDetailsCore.isStepByStepMode()) {
              if (_productDetailsCore.getState(_productDetailsCore.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE)) {
                _updateBlockPriceContainer(productContainerBlockPricing, productFields.product.price_info.block_pricing, false);
              }
            } else {
              _updateBlockPriceContainer(productContainerBlockPricing, productFields.product.price_info.block_pricing, false);
            }
          }
        }

        function _resetPreview(preview, time, newPreviewImage) {
          setTimeout(function () {
            preview.removeClass('preview-shown preview-refresh');
            preview.attr('src', newPreviewImage);
          }, time);
        }

        // change images
        if (productFields.product.update_image_gallery && productFields.product.has_image) {
          var $previewImage = $('.preview-image');
          var $newPreviewImage = productFields.product.image_urls[0].image_url_440;

          $previewImage.addClass('preview-refresh preview-shown');

          // remove old swiper
          if (productImagesSwiper) {
            productImagesSwiper.destroy(true);
            $swiperContainer.removeAttr('style');
            $swiperWrapper.removeAttr('style');
            $swiperPagination.empty();
            productImagesSwiper = null;
          }

          // empty wrapper and add new images
          $swiperWrapper.empty().height('');

          // Get the parameter that contains a special configured resolution for the gallery.
          // Since this high resolution only makes sense for zoomed images, and the TouchNSwipe
          // gallery is used for this feature, it's mapped to a special parameter for the markup
          // preparation of this plugin
          var zoomGalleryResolution = params.ui.imageGalleryResolution;

          $.each(productFields.product.image_urls, function (index, image) {
            var attributes = {
              src: image.image_url_640,
              class: 'img-responsive',
              width: 300,
              height: 300,
              'data-link': 'slider:#tnsSlider; index:' + index,
              'data-index': index,
            };

            if (_productDetailsCore.options.isApp) {
              // For the apps the default gallery images get a special parameter that
              // contains the image url for the zomm gallery
              var useHighResImage = !!zoomGalleryResolution &&
                image['image_url_' + zoomGalleryResolution];

              if (useHighResImage) {
                attributes['data-gallery-url'] = image['image_url_' + zoomGalleryResolution];
              } else {
                attributes['data-gallery-url'] = image.image_url_640;
              }
            }

            $swiperWrapper.append($('<img>').attr(attributes));
          });

          // init swiper
          if (productFields.product.image_urls.length > 1) {
            $swiperWrapper
              .children()
              .wrap('<div class="swiper-slide"><div class="content-slide"></div></div>');

            productImagesSwiper = new Swiper($swiperContainer[0], {
              pagination: $swiperPagination[0],
              loop: false,
              grabCursor: true,
              paginationClickable: false,
              calculateHeight: true,
              slidesPerView: 1,
              watchActiveIndex: true,
              resizeReInit: true,
              onInit: function (swiper) {
                if (swiper.isAndroid) {
                  swiper.updateActiveSlide();
                  swiper.updatePagination();
                }
                // make sure first/current slide is inserted in previewImage container
                _resetPreview($previewImage, 1500, $newPreviewImage);
              },
              onImagesReady: function () {
                // make sure first/current slide is inserted in previewImage container
                _resetPreview($previewImage, 1500, $newPreviewImage);
              },
              onSlideChangeStart: function (swiper) {
                // override newPreviewImage with the current visible due to swiping (activeIndex)
                $newPreviewImage = productFields
                  .product
                  .image_urls[swiper.activeIndex]
                  .image_url_440;

                _resetPreview($previewImage, 1500, $newPreviewImage);
              },
            });
          } else if (productFields.product.image_urls.length === 1) {
            _resetPreview($previewImage, 1500, $newPreviewImage);
          } else {
            _resetPreview($previewImage, 1500, $newPreviewImage);
          }

          if (typeof TouchNSwipe === 'function' && !_productDetailsCore.options.isApp) {
            // TouchNSwipe is used to present a zoomable gallery at the product page
            // Since the TouchNSwipe library is quite big, it was removed within TD-320 / PI-5995
            // from the common.js files an put into a special bundle that are only loaded at pages
            // that need it.
            // This ui-script is shared between the default templates of the mobile website and the
            // apps. Within the apps the gallery is presented within the
            // "image gallery notification", and so the TouchNSwipe is not loaded on the product
            // page itself. So we only create the related markup, when the library is available
            // outside the app.
            TouchNSwipe.removeAll();
            var dataAttrOnOff =
              'data-on="autoAlpha:1; cursor: pointer;" data-off="autoAlpha:0.5; cursor:default"';

            var $galleryDiv = $('<div id="tnsSlider" class="slider" data-elem="slider" ' +
              'data-options="initShow:false; resetScrollDuration:1;" data-show="autoAlpha:1; ' +
              'display:block" data-hide="autoAlpha:0; display:none">' +
              '<div class="sliderBg blackBgAlpha75"></div>' +
              '<div class="slides" data-elem="slides" data-options="resizeDuration:1; ' +
              'adjustHeight:-30; showPreloader: ' + (!!zoomGalleryResolution ? 'true' : 'false') +
              '"></div><div class="controlHolder">' +
              '<div class="prevIcon controlPos1" data-elem="prev" ' + dataAttrOnOff + '>' +
              '<i class="sg sg-chevron-left"></i></div>' +
              '<div class="nextIcon controlPos2" data-elem="next" ' + dataAttrOnOff + '>' +
              '<i class="sg sg-chevron-right"></i></div>' +
              '<div class="zoomOutIcon controlPos4" data-elem="zoomOut" ' + dataAttrOnOff + '>' +
              '<i class="sg sg-minus"></i></div>' +
              '<div class="zoomInIcon controlPos5" data-elem="zoomIn" ' + dataAttrOnOff + '>' +
              '<i class="sg sg-plus"></i></div>' +
              '<div class="closeIcon controlPos7" data-elem="close">' +
              '<i class="sg sg-close"></i></div>' +
              '</div>' +
              '<div class="thumbsHolder"data-elem="thumbsHolder">' +
              '<div class="thumbs blackBgAlpha60" data-elem="thumbs" ' +
              'data-options="initShow:true; space:5; resizeDuration:0.01; borderColor:#808080;" ' +
              'data-show="" data-hide="" ></div>' +
              '</div>' +
              '</div>').appendTo($tnsContainer);

            // Create the slides
            var $itemList = $('<ul data-elem="items"></ul>').appendTo($galleryDiv);

            $.each(productFields.product.image_urls, function (index, image) {
              var imageUrlThumbnail = image.image_url_640;
              var imageUrlSlide = image.image_url_640;

              // Use a high resolution image for the zoom gallery if the shop has configured it
              if (zoomGalleryResolution && image['image_url_' + zoomGalleryResolution]) {
                imageUrlSlide = image['image_url_' + zoomGalleryResolution];
              }

              // When the zoom gallery image is added as an anchor, it's not directly loaded
              // by the browser - just when it's necessary (doesn't count for the first one).
              // For the thumbs the regular image is used. It doesn't cause additional requests
              // since, they are already used for the default gallery.
              var $listItem = $('<li>');
              var $slideWrapper = $('<a>').attr({href: imageUrlSlide});
              var $slide = $('<img>').attr({src: imageUrlThumbnail, alt: ''});

              $itemList.append($listItem.append($slideWrapper.append($slide)));
            });

            TouchNSwipe.init();

            // Prevents close button from bubbling up and clicks
            // what lays behind (cartbutton or search or ...)
            $('.closeIcon', $galleryDiv).on('touchstart', function () {
              return false;
            });
          }

          $swiperWrapper.find('img').css({
            touchAction: '',
          });
        }

        var uiWithTabs = productDescriptionTabs.length > 0,
          hasReviews = productDescriptionTabs.find('#product-reviews').length > 0,
          hasDescription = false,
          hasProperties = false;

        // change the description
        if (productFields.product.description) {
          hasDescription = true;
          productDescription.html(productFields.product.description);

          if (!uiWithTabs) {
            productDescription.closest('.panel').removeClass('hidden').addClass('show');
          } else {
            productDescription.removeClass('hidden').addClass('show').parent().removeClass('hidden').addClass('show');
          }
        } else {
          productDescription.html('');

          if (!uiWithTabs) {
            productDescription.closest('.panel').removeClass('show').addClass('hidden');
          } else {
            productDescription.removeClass('show').addClass('hidden').parent().removeClass('show').addClass('hidden');
          }
        }

        // change the properties
        if (productFields.product.properties && Object.keys(productFields.product.properties).length) {
          hasProperties = true;
          productProperties.html('');

          var properties = productFields.product.properties;
          $.each(properties, function (key, value) {
            productProperties.append('<div class="row"><div class="col-xs-6">' + key + '</div><div class="col-xs-6">' + value + '</div></div>');
          });

          if (!uiWithTabs) {
            productProperties.closest('.panel').removeClass('hidden').addClass('show');
          } else {
            productProperties.removeClass('hidden').addClass('show');
          }
        } else {
          productProperties.html('');

          if (!uiWithTabs) {
            productProperties.closest('.panel').removeClass('show').addClass('hidden');
          } else {
            productProperties.removeClass('show').addClass('hidden');
          }
        }

        if (uiWithTabs) {
          productDescriptionTabs.find('.nav-tabs li:first').toggleClass('hidden', (!hasDescription && !hasProperties));

          if (hasReviews) {

            if (!hasDescription && !hasProperties) {
              productDescriptionTabs.find('.nav-tabs a:last').tab('show');
            } else {
              productDescriptionTabs.find('.nav-tabs a:first').tab('show');
            }
          } else {

            productDescriptionTabs.find('.tab-content').toggleClass('hidden', (!hasDescription && !hasProperties));
          }
        }

        if (productFields.product.amount_info_text) {
          productContainerAmountInfoText.html(productFields.product.amount_info_text);
          productContainerAmountInfoText.removeClass('hidden');
        } else {
          productContainerAmountInfoText.empty();
          productContainerAmountInfoText.addClass('hidden');
        }

        // change the available text (stock info)
        productContainerStockInfo.html(productFields.product.stock_text);
        productContainerStockInfo.closest('.row').toggle(Boolean(productFields.product.stock_text));

        var showAvailableText = !(productFields.product.stock_text && productFields.product.stock_quantity == 0);
        if (showAvailableText) {
          productContainerAvailableText.html(productFields.product.available_text);
        }
        productContainerAvailableText.toggle(showAvailableText);

        if (typeof ShopgateProductDetailsCore == 'object' && ShopgateProductDetailsCore.isComponentActive('livestock')) { //show or hide stock if livestock is active depending on ignore_stock
          productContainerLiveStock.closest('.row').toggle(!Boolean(productFields.product.ignore_stock));
        }

        if (typeof data.product_price_info != 'undefined') {
          _onUpdateProductPriceInfo('products.ui', {
            price_info: data.product_price_info
          })
        }
      }

      // disable is stepbystep mode, see stepbystep-ui
      if (!_productDetailsCore.isStepByStepMode()) {
        // handle the product attributes
        if (data.product_attributes) {
          attributesContainer.empty();

          $.each(data.product_attributes, function (key, productAttribute) {
            addProductAttribute(productAttribute);
          });

          scope.find('.product-attributes-wrapper').show();
        }
      }

      // handle the product options
      if (data.product_options) {
        optionsContainer.empty();

        $.each(data.product_options, function (key, productOption) {
          addProductOption(productOption);
        });

        scope.find('.product-options-wrapper').show();
      }

      // handle the product input fields
      if (data.product_input_fields) {
        inputFieldsContainer.empty();

        $.each(data.product_input_fields, function (key, productInputField) {
          addProductInputField(productInputField);
        });

        scope.find('.product-input-fields-wrapper').show();
      }

      $(document).trigger('shopgateFramework.ui.product.updated', data);

      if (params.isApp) {
        // update the share button
        var shareData = _productDetailsCore.getShareDataForCurrentSelectedProduct();

        SGAction.setNavigationBarParams({
          title: shareData.title,
          navigationBarParams: {
            type: 'product',
            deeplink: shareData.deeplink,
            imageUrl: shareData.imageUrl,
          },
        });
      }
    }
  }

  function _onUpdateProductPriceInfo(callType, data) {
    // TODO improve this and adjust the price_info element ..
    // change the strike price text and label
    var priceIsInterval = false,
      displayPrice = data.price_info.unit_amount_display_formatted;

    if (_productDetailsCore.isStepByStepMode() &&
      !_productDetailsCore.getState(_productDetailsCore.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE) &&
      (!_productDetailsCore.getState('stockUpdatePending') ||
      !_productDetailsCore.isChildProduct(_productDetailsCore.getSelectedProduct()))
    ) {
      var basePrice = data.price_info.unit_amount_display,
        highestPrice = (data.price_info.highest_sibling_price > basePrice) ? data.price_info.highest_sibling_price : basePrice,
        lowestPrice = (data.price_info.lowest_sibling_price < basePrice) ? data.price_info.lowest_sibling_price : basePrice;

      if (highestPrice != lowestPrice) {
        priceIsInterval = true;
        displayPrice = $.i18n._('price_starting_from') + ' ' + data.price_info.lowest_sibling_price_formatted;
        if (data.price_info.lowest_sibling_price_formatted_gross) {
          var priceIntervalTextGross = data.price_info.lowest_sibling_price_formatted_gross;
        }
      }
    }

    if (!priceIsInterval && typeof data.price_info.strike_price_display_formatted !== 'undefined') {
      productContainerPriceMainDiscounted.removeClass('hidden');
      productContainerPriceMainNormal.addClass('hidden');

      let strikePriceGross = '';

      if (data.price_info.gross && data.price_info.gross.strike_price_display_formatted) {
        strikePriceGross = ` (${data.price_info.gross.strike_price_display_formatted})`;
      }

      productContainerPriceOld.text(`${data.price_info.strike_price_display_formatted}${strikePriceGross}`);

      if (data.price_info.price_label) {
        productContainerPriceOldLabel.text(data.price_info.price_label);
      }

      // change the discount price text and label
      if (data.price_info.unit_amount_display_formatted) {
        productContainerPriceDiscount.text(data.price_info.unit_amount_display_formatted);

        if (data.price_info.discount_label) {
          productContainerPriceDiscountLabel.text(data.price_info.discount_label);
        }
      }
    } else {
      productContainerPriceMainNormal.removeClass('hidden');
      productContainerPriceMainDiscounted.addClass('hidden');
      productContainerPriceOld.empty();
      productContainerPriceOldLabel.empty();
      productContainerPriceDiscount.empty();
      productContainerPriceDiscountLabel.empty();
    }

    // change the price tag text
    if (data.price_info.discount_percent_formatted) {
      productContainerPriceTag.text('- ' + data.price_info.discount_percent_formatted);
      productContainerPriceTag.removeClass('hidden').addClass('show');
    } else {
      productContainerPriceTag.empty();
      productContainerPriceTag.removeClass('show').addClass('hidden');
    }

    // change the price
    if (displayPrice) {
      productContainerPrice.text(displayPrice);
    }

    if (priceIsInterval && data.price_info.strike_price_display_formatted) {
      /**
       * At strike prices the discount_label is usually used as label for the current price.
       * Due to the logic above for "from prices", the price label has to be updated
       * with the value of this property.
       */
      productContainerPriceLabel.text(data.price_info.discount_label);
    } else if (data.price_info.price_label) {
      productContainerPriceLabel.text(data.price_info.price_label);
    }

    if (data.price_info.gross && data.price_info.gross.unit_amount_display_formatted) {
      if (priceIsInterval) {
        $('.gross-price-container').text(priceIntervalTextGross);
      } else {
        $('.gross-price-container').text(data.price_info.gross.unit_amount_display_formatted);
      }
    }
  }

  function _onShowProductAttributeValuesList(callType, data) {
    if (callType !== 'products.ui') {
      return;
    }
    if (_productDetailsCore.isStepByStepMode()) {
      return;
    }

    var productAttributeId = data.product_attribute.id;
    var productAttributeSelect = $('#attribute_select_value_' + productAttributeId);

    if (!productAttributeSelect) {
      return;
    }

    // clear the select
    productAttributeSelect.empty();

    $.each(data.product_attribute.values, function (key, productAttributeValue) {

      var productAttributeSelectOption =
            $('<option>')
              .addClass('no-sg-action')
              .html(productAttributeValue.product_attribute_value.name)
              .val(productAttributeValue.product_attribute_value.product_id)
              .attr('data-subtext',
                productAttributeValue.product_attribute_value.product_attribute_name + ': ');

      // append the options to the select
      productAttributeSelect.data({
        value: productAttributeValue,
      }).append(productAttributeSelectOption);

      // TODO: check for stylings for selectable/orderable if they are not
      // if attribute is not selectable
      if (!productAttributeValue.product_attribute_value.selectable) {
        productAttributeSelectOption.attr('disabled', 'disabled');
      }

      // if attribute is not orderable
      if (!productAttributeValue.product_attribute_value.orderable) {
        productAttributeSelectOption.attr('disabled', 'disabled');
      }

      // if attribute is selected
      if (productAttributeValue.product_attribute_value.selected) {
        productAttributeSelectOption.attr('selected', 'selected');
      }

      // if attribute is selectable
      if (productAttributeValue.product_attribute_value.selectable) {
        // do nothing here in first place
      }
    });

    // refresh the select
    productAttributeSelect
      .selectpicker('refresh')
      .selectpicker('setSize');
  }

  function _onHideProductAttributeValuesList(callType, data) {
    if (callType && callType != 'products.ui') {
      return;
    }
    if (_productDetailsCore.isStepByStepMode()) {
      return;
    }

    var productAttributeId = data.product_attribute.id,
      productAttributeSelect = $('#attribute_select_value_' + productAttributeId);

    if (!productAttributeSelect) {
      return false;
    }

    _productDetailsCore.productAttributeValueListIsHidden(data.product_attribute.product_id, data.product_attribute.id);
  }

  function _onShowProductOptionValuesList(callType, data) {
    if (callType != 'products.ui') {
      return;
    }

    var productOptionId = data.product_option.id,
      productOptionSelect = $('#option_select_value_' + productOptionId),
      productOptionDropdownList = $('#option_value_' + productOptionId);

    if (!productOptionSelect) {
      return false;
    }

    productOptionSelect.empty();

    $.each(data.product_option.values, function (key, productOptionValue) {
      var optionValueText = productOptionValue.product_option_value.name;

      if (productOptionValue.product_option_value.price_info.additional_amount_display != 0) {
        optionValueText += (productOptionValue.product_option_value.price_info.additional_amount_display > 0 ? ' (+' : ' (');
        optionValueText += productOptionValue.product_option_value.price_info.additional_amount_display_formatted;
        optionValueText += ")";
      }
      var productOptionSelectValue = $('<option>').addClass('no-sg-action').html(optionValueText).val(productOptionValue.product_option_value.id).attr('data-subtext', data.product_option.name + ': ');

      productOptionSelect.data({
        value: productOptionValue
      }).append(productOptionSelectValue);

      // if attribute is selected
      if (productOptionValue.product_option_value.selected) {
        productOptionSelectValue.attr('selected', 'selected');
      }
    });

    productOptionSelect
      .selectpicker('refresh')
      .selectpicker('setSize');

    // not sure if there is an other way to manipulate the selected option
    productOptionDropdownList.find('.filter-option').html('<small class="muted text-muted">' + data.product_option.name + ': </small>' + data.product_option.value);
  }

  function _onHideProductOptionValuesList(callType, data) {
    if (callType && callType != 'products.ui') {
      return;
    }

    var productOptionId = data.product_option.id,
      productOptionDropdownList = $('#option_value_' + productOptionId);

    if (!productOptionDropdownList) {
      return false;
    }

    // (re-)initialize select
    $('.selectpicker').selectpicker({
      style: 'btn-default',
      dropupAuto: true,
      showSubtext: true
    });

    // not sure if there is an other way to manipulate the selected option
    productOptionDropdownList.find('.filter-option').html('<small class="muted text-muted">' + data.product_option.name + ': </small>' + data.product_option.value);

    _productDetailsCore.productOptionValueListIsHidden(data.product_option.product_id, data);
  }

  function _onUpdateProductInputField(callType, data) {
    if (callType && callType != 'products.ui') {
      return;
    }

    var productInputField = inputFieldsContainer.find('#input_' + data.product_input_field.id);

    productInputField.val(data.product_input_field.value);

    if (data.product_input_field.is_required) {
      if (data.product_input_field.is_valid) {
        productInputField.closest('.form-group').removeClass('has-error');
      } else {
        productInputField.closest('.form-group').addClass('has-error');
      }
    }
  }

  /*
   *
   * updates the states of the #add-to-cart button and the stock quantity
   * @param callType -
   * @param data - holds the following information: cartButtonLocked, stockQuantityPending, cartButtonBusy
   *
   */
  function _onUpdateStates(callType, data) {
    if (callType && callType != 'products.ui') {
      return;
    }

    // if cart button is locked
    if (typeof data.cartButtonLocked != 'undefined') {
      cartButton.toggleClass('locked', data.cartButtonLocked);
    }

    // on stock quantity is pending
    if (typeof data.stockUpdatePending != 'undefined') {}

    // on product update pending
    if (typeof data.productUpdatePending != 'undefined') {}

    // on price update pending
    if (typeof data.priceUpdatePending != 'undefined') {
      if (data.priceUpdatePending) {
        $('.js-hide-while-preloading-price').addClass('hidden');
        $('.js-container-price').addClass('hidden');
        pricePreloader.removeClass('hidden');
      } else {
        $('.js-hide-while-preloading-price').removeClass('hidden');
        $('.js-container-price').removeClass('hidden');
        pricePreloader.addClass('hidden');
      }
    }

    // if cart button is busy
    if (typeof data.cartButtonBusy != 'undefined') {
      cartButton.not('.js-btn-cart-child').toggleClass('loading', data.cartButtonBusy);
    }

    var disableCartButton = _productDetailsCore.isAddToCartButtonDisabled();

    cartButton.toggleClass('disabled', disableCartButton);
  }

  /*
   *
   * handles the functionality when the #add-to-cart button is clicked
   * @param callType -
   * @param data - holds the following information: is_parent_product, parent_product_id, product, product_attributes, product_input_fields, product_options, quantity
   *
   */
  function _onProductAddedToCart(callType, data) {
    if (callType && callType != 'products.ui') {
      return;
    }

    // used for tracking logic
    $(document).trigger('shopgateFramework.product.addedToCart', data);

    var cartDropDown = $('#merchant-bar-cart'),
      productFrame = $('.product-frame', cartDropDown).hide(),
      headline = $('.headline', cartDropDown),
      imageContainer = $('.image-container', cartDropDown),
      amount = $('.properties .properties-amount span', cartDropDown),
      price = $('.properties .properties-price span', cartDropDown);

    if (data && Array.isArray(data.products) && data.products.length == 1 && data.display_type != _productDetailsCore.DISPLAY_TYPE_LIST) {
      var productData = data.products[0];

      productFrame.show();

      if (productData.product.name) {
        headline.html(productData.product.name);
      }

      if (productData.product.image_urls) {
        var image = $('<img>').prop({
          src: productData.product.image_urls[0].image_url_440,
          height: '400',
          width: '400'
        }).addClass('img-responsive');
        imageContainer.html(image);
      }

      if (productData.quantity) {
        amount.text(productData.quantity);
      }

      if (productData.product_price_info.unit_amount_display_formatted) {
        price.text(productData.product_price_info.unit_amount_display_formatted);
      }

      if (productData.product_attributes) {

        price.parents('p').siblings('.properties-attributes').remove();

        $.each(productData.product_attributes, function () {
          var html = '';
          html += '<p class="properties-attributes"><strong>' + this.product_attribute.name + ': </strong><span>' + this.product_attribute.value + '</span></p>';
          price.parents('p').before(html);
        });
      }
    }

    if (params.ui.useGenericNotification) {
      var modalParams = {
        timeout: params.ui.modalTimer ? params.ui.modalTimer : 6000,
        offsets: params.ui.modalOffsets ? params.ui.modalOffsets : {
          top: 0,
          bottom: 0
        },
        executeOnClick: false,
        notificationParams: {
          genericNotification: {
            title: false,
            message: cartDropDown.clone().removeClass('collapse').find('.js-modal-content').text(),
            primaryButton: $.i18n._('notification_continue_shopping'),
            secondaryButton: $.i18n._('notification_proceed_to_cart'),
            secondaryButtonAction: params.urlCart,
            closeButtonOutsideNotification: false,
            customCssClass: 'cart-popup-notification'
          }
        }
      };

      cartButton.genericNotification(modalParams);

    } else if (params.ui.switchToCartAfterAddedToCart) {
      // for the apps
      if (typeof SGAction.showTab == 'function') {
        SGAction.popTabToRoot({
          targetTab: 'cart'
        });
        SGAction.showTab({
          targetTab: 'cart'
        });

        // for the mobile website
      } else {
        window.location.href = params.urlCart;
      }
    } else if (params.ui.successOnCTA) {
      var $cta = $('#add-to-cart');

      $cta.one("transitionend webkitTransitionEnd", function () {
        setTimeout(function () {
          $cta.removeClass('item-added');
        }, 650);
      }).addClass('item-added');

    } else {
      $('html, body').animate({
        scrollTop: 0
      }, 'slow', function () {
        // Animation complete.
        cartDropDown.collapse('show');

        if ($('#backdrop-cart').length == 0) {
          $('#backdrop').show();
        }
      });

      // close cart popup after 5 seconds (but not if paypal express button is clicked) or on user action
      var closePopupTimer;

      function clearTimer() {
        window.clearInterval(closePopupTimer);
      };

      var paypalExpressBtn = $('.paypal-express-button', cartDropDown).one('click', clearTimer);

      function closeCartPopup() {
        clearTimer();
        paypalExpressBtn.off('click', clearTimer);
        cartDropDown.collapse('hide');
        $('#backdrop').hide();
      }

      closePopupTimer = window.setInterval(closeCartPopup, 5000);

      $(document).on('click', '#backdrop, .close-merchant-cart', closeCartPopup);
    }
  }

  function _onCartButtonPressed(callType, data) {
    if (callType && callType != 'products.ui') {
      return;
    }
    cartButton.not('.js-btn-cart-child').addClass('pressed');
  }

  function _onUpdateCartProductQuantity(callType, data) {
    if (callType && callType != 'products.ui') {
      return;
    }

    // Fake quantity 1 for grouped product with add-to-cart buttons
    if (_productDetailsCore.products.parent.product.display_type == _productDetailsCore.DISPLAY_TYPE_LIST && shopSettings.productDisplayListWithCta && data.quantity == 0) {
      data.quantity = 1;
    }

    $('.container-product-quantity[data-product-id=' + data.productId + '] .item-amount').val(data.quantity);
  }

  function _onUpdateProductPrice(callType, data) {
    if (callType && callType != 'products.ui') {
      return;
    }

    // handle the price update stuff here
  }

  var hooks = {
    vendor: 'shopgate',
    name: 'ShopgateUI',
    type: ['products.ui', 'products.data'],
    onCoreInit: _onCoreInit,
    onUpdateProduct: _onUpdateProduct,
    onShowProductAttributeValuesList: _onShowProductAttributeValuesList,
    onHideProductAttributeValuesList: _onHideProductAttributeValuesList,
    onShowProductOptionValuesList: _onShowProductOptionValuesList,
    onHideProductOptionValuesList: _onHideProductOptionValuesList,
    onUpdateProductInputField: _onUpdateProductInputField,
    onUpdateProductPriceInfo: _onUpdateProductPriceInfo,
    onUpdateStates: _onUpdateStates,
    onUpdateCartProductQuantity: _onUpdateCartProductQuantity,
    onCartButtonPressed: _onCartButtonPressed,
    onProductAddedToCart: _onProductAddedToCart,
  };

  return hooks;
};

if (typeof ShopgateProductDetailsCore == 'object' && typeof ShopgateProductDetailsCore.registerPlugin == 'function') {
  ShopgateProductDetailsCore.registerPlugin(shopgateUI);
} else {
  console.error('No instance of "ShopgateProductDetailsCore" found');
}



// WEBPACK FOOTER //
// ./Library/1.0/phone/product_details/jquery.shopgate-product-details-ui-plugins.js